import React from 'react';
import { Button } from '@mui/material';
import { useRequestReindexing } from '@hooks/useSEO';
import SpinningIcon from '@components/SpinningIcon';

interface RequestReindexingButtonProps {
  url: string;
}

const RequestReindexingButton: React.FC<RequestReindexingButtonProps> = ({
  url
}) => {
  const { mutate: requestReindexing, isLoading: isRequesting } =
    useRequestReindexing();

  return (
    <Button
      variant="outlined"
      color="primary"
      onClick={() => {
        requestReindexing({ url });
      }}
      disabled={isRequesting}
      startIcon={isRequesting ? <SpinningIcon isLoading /> : null}
      sx={{
        maxWidth: '200px'
      }}
    >
      {isRequesting ? 'Requesting' : 'Request Reindexing'}
    </Button>
  );
};

export default RequestReindexingButton;
